import { type ReactNode } from 'react'

import { Modal, TransparentIconButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import sparkleSVG from './assets/sparkle.svg'
import messages from './messages'
import {
  GlobalCommandModalBodyContentStyled,
  GlobalCommandModalBodyStyled,
  GlobalCommandModalCloseAreaStyled,
  GlobalCommandModalFooterContentStyled,
  GlobalCommandModalFooterStyled,
  GlobalCommandModalHeaderIconStyled,
  GlobalCommandModalHeaderStyled,
  GlobalCommandModalMainStyled,
  GlobalCommandModalShellStyled,
  GlobalCommandModalTitleStyled,
} from './styles/GlobalCommandModalLayoutStyled'

const dismissPopovers = () => document.body.click()

interface IGlobalCommandModalProps {
  isOpen: boolean
  onClose: () => void
  onEntered?: () => void
  children: ReactNode
  isConversation?: boolean
  title?: ReactNode
  footer?: ReactNode
  sidePanel?: ReactNode
}

export const GlobalCommandModal = ({
  isOpen,
  onClose,
  onEntered,
  children,
  isConversation = false,
  title,
  footer,
  sidePanel,
}: IGlobalCommandModalProps) => {
  const intl = useProcurifyIntl()

  return (
    <Modal
      aria-label={intl.formatMessage(messages.modalAriaLabel)}
      maxWidth={false}
      open={isOpen}
      onClose={onClose}
      keepMounted
      TransitionProps={{ onEnter: dismissPopovers, onEntered }}
    >
      <Modal.Card cycleFocus>
        <GlobalCommandModalShellStyled $isConversation={isConversation}>
          <GlobalCommandModalCloseAreaStyled>
            <TransparentIconButton
              aria-label={intl.formatMessage(messages.closeButtonAriaLabel)}
              icon='times'
              analyticsId='global-search-close-button'
              onClick={onClose}
            />
          </GlobalCommandModalCloseAreaStyled>

          <GlobalCommandModalMainStyled>
            {isConversation && (
              <GlobalCommandModalHeaderStyled>
                <GlobalCommandModalHeaderIconStyled src={sparkleSVG} />
                {title && (
                  <GlobalCommandModalTitleStyled>
                    {title}
                  </GlobalCommandModalTitleStyled>
                )}
              </GlobalCommandModalHeaderStyled>
            )}

            <GlobalCommandModalBodyStyled $isConversation={isConversation}>
              <GlobalCommandModalBodyContentStyled
                $isConversation={isConversation}
              >
                {children}
              </GlobalCommandModalBodyContentStyled>
            </GlobalCommandModalBodyStyled>

            {isConversation && footer && (
              <GlobalCommandModalFooterStyled>
                <GlobalCommandModalFooterContentStyled>
                  {footer}
                </GlobalCommandModalFooterContentStyled>
              </GlobalCommandModalFooterStyled>
            )}
          </GlobalCommandModalMainStyled>

          {isConversation && sidePanel}
        </GlobalCommandModalShellStyled>
      </Modal.Card>
    </Modal>
  )
}
